import {useState} from "react";

const useProgressiveInput = (
    progressiveFunc: (...args: any[]) => void,
    duration: number
) => {
    const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);

    const setTimeoutFunc = (...args: any[]) => {
        clearTimeoutFunc();
        setTimer(setTimeout(() => progressiveFunc(...args), duration));
    };

    const clearTimeoutFunc = () => {
        if (timer) {
            clearTimeout(timer);
        }
    };

    return [setTimeoutFunc, clearTimeoutFunc];
};

export default useProgressiveInput;
